import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import "../styles/Header.css";

const translations = {
  ES: {
    home: "Home",
    editorial: "Editorial",
    contacto: "Contacto",
  },
  CAT: {
    home: "Inici",
    editorial: "Editorial",
    contacto: "Contacte",
  },
};

const sections = ["home", "editorial", "contacto"];

const Header = ({ contactRef }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { language, toggleLanguage } = useLanguage();
  const [menuOpen, setMenuOpen] = useState(false);
  const [isLanguageDropdownOpen, setIsLanguageDropdownOpen] = useState(false);

  const [activeSection, setActiveSection] = useState("home");

  useEffect(() => {
    const path = location.pathname.replace("/", "") || "home";
    setActiveSection(path);
  }, [location]);

  const handleContactClick = (e) => {
    if (e) e.preventDefault();

    // Close the menu when contact is clicked
    setMenuOpen(false);

    // Check if we're on an article page
    if (location.pathname.includes("/articulo/")) {
      // Navigate to Editorial page and set flag to scroll to contact
      sessionStorage.setItem("scrollToContact", "true");
      navigate("/editorial");
    } else if (contactRef.current) {
      // Normal behavior for other pages
      contactRef.current.scrollIntoView({ behavior: "smooth" });
      setActiveSection("contacto");
    }
  };

  const handleNavClick = (id) => {
    // Close the menu when any nav item is clicked
    setMenuOpen(false);

    if (id === "contacto") {
      handleContactClick(null);
    } else {
      setActiveSection(id);
    }
  };

  return (
    <header className="header">
      <div className="header-container">
        <Link to="/" className="logo" onClick={() => setMenuOpen(false)}>
          <div className="logo">
            <div className="logo-img"></div>
          </div>
        </Link>

        <button
          className="hamburger-button"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle navigation menu"
        >
          ☰
        </button>

        <nav
          className={`nav ${menuOpen ? "open" : ""}`}
          aria-label="Main navigation"
        >
          <ul className="nav-list">
            {sections.map((id) => (
              <li key={id} className={activeSection === id ? "active" : ""}>
                <Link
                  to={id === "home" ? "/" : `/${id}`}
                  className={`nav-link ${activeSection === id ? "active" : ""}`}
                  onClick={(e) => {
                    if (id === "contacto") {
                      handleContactClick(e);
                    } else {
                      handleNavClick(id);
                    }
                  }}
                  aria-current={activeSection === id ? "page" : undefined}
                >
                  {translations[language][id]}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <div className="language-menu">
          <button
            className="language-button"
            onClick={() => setIsLanguageDropdownOpen(!isLanguageDropdownOpen)}
          >
            {language} ▼
          </button>
          {isLanguageDropdownOpen && (
            <div className="language-dropdown">
              <button
                onClick={() => {
                  toggleLanguage();
                  setIsLanguageDropdownOpen(false);
                }}
              >
                {language === "CAT" ? "ES" : "CAT"}
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
